module.exports = __webpack_public_path__ + "static/media/testimonial (8).1c9f4d19.png";